module.exports = __webpack_public_path__ + "static/media/LV-GPQ.ed8d4a0b.jpg";